import React, { useContext, useEffect, useState } from "react";
import { CustomTooltip } from "../../../../../../styles/TooltipStyles";
import useLabels from "../../../../../../customHooks/useLabels";
import { TOOLTIP_COLORS } from "../../../../../../styles/Variables";
import Information from "../../../../../../images/Info.svg";
import { AssetDetail } from "../AssetDetails";
import { useLazyQuery } from "@apollo/client";
import {
  GetCompOrJuncOrAssetOrSubAndSiteNodeResult,
  GetCompOrJuncOrAssetOrSubAndSiteNodeVars,
} from "../../../masters/items/queries/types";
import { CompOrJuncOrAssetOrSubAndSiteNode } from "../../../masters/items/queries/queries";

import { MapsContext } from "../../context/context";
import {
  CustomModal,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import { EMPTY_STRING } from "../../../../../../utils/constants";
import ViewAsset from "../../../purchase/stockentry/ViewAsset";
import {
  ViewItemsModalStyles,
  ViewTicketModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import {
  CustomDrawer,
  JunctionDetailsDrawer,
} from "../../../../../../styles/CustomDrawerStyles";
import ViewJunctionDetails from "./ViewJunctionDetails";
import { TableType } from "../../../../customer/companies/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import { PriorityEnum } from "../../../../../../utils/Enum.types";
import { mapsPayloadType } from "../../context/reducer";
interface Props {
  assetType: TableType;
  viewIcon?: boolean;
}
const ItemDetails = ({ assetType, viewIcon }: Props) => {
  const [itemId, setItemdId] = useState(0);
 
  const { state, dispatch } = useContext(MapsContext);

  const emptyObject: AssetDetail = {
    code: "",
    serial_no: "",
    batch: "",
    expiry: "",
    s_date: "",
    e_date: "",
    maintained_by: "",
    geo_location: "",
    asset_location: "",
    installation_date: "",
    subsidiaryName: "",
    suppliername: "",
    desc: "",
    id: 0,
    img: "",
    name: "",
    slNo: 0,
    companyId: 0,
    arms: 0,
    jType: "",
    priority: "",
    siteName: "",
    address:""
  };
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);

  const [assetDetail, setAssetDetail] = useState<AssetDetail>(emptyObject);
  const [junctionDetails, setJunctionDetails] = useState(false);
  const { itemLabel } = useLabels();

  const [GetItemDetails, { data }] = useLazyQuery<
    { node: GetCompOrJuncOrAssetOrSubAndSiteNodeResult },
    GetCompOrJuncOrAssetOrSubAndSiteNodeVars
  >(CompOrJuncOrAssetOrSubAndSiteNode);

  useEffect(() => {
    const fetchProperData = (
      node: GetCompOrJuncOrAssetOrSubAndSiteNodeResult
    ): AssetDetail => {
      let assetData: AssetDetail = emptyObject;
      let img = "";

      switch (assetType) {
        case TableType.ASSET:
          img = require(`../../../../../../images/ItemIcons/${node.item.icon}.svg`);

          return {
            ...assetDetail,
            batch: node.prodBatchNo,
            code: node.item.code,
            expiry: toStandardDate(node.prodExpiryDate),
            geo_location: `${node.prodLatitude},${node.prodLongitude}`,
            e_date: toStandardDate(node.prodWarrantyEndDate),
            installation_date: toStandardDate(node.prodInstallationEndDate),
            maintained_by: "",
            s_date: toStandardDate(node.prodWarrantyEndDate),
            serial_no: node.prodSerialNo,
            suppliername: node.vendorDetails.desc,
            subsidiaryName: node.currentSubsidiary.name,
            desc: `${node.prodSerialNo} (${node.item.desc})`,
            id: node.id,
            img,
            name: `${node.prodSerialNo} (${node.item.desc})`,
            slNo: 0,
            companyId: node.curCompanyID,
            arms: node.arms,
            jType: node.jType,
            priority: node.priority,
            siteName: node.currentSite.name,
            address: node?.address
          };

        case TableType.JUNCTION:
          img = require(`../../../../../../images/ItemIcons/${node.icon}.svg`);
          return {
            ...assetDetail,
            batch: EMPTY_STRING,
            code: node.code,
            expiry: EMPTY_STRING,
            geo_location: `${node.latitude},${node.longitude}`,
            e_date: EMPTY_STRING,
            installation_date: EMPTY_STRING,
            maintained_by: "",
            s_date: EMPTY_STRING,
            serial_no: EMPTY_STRING,
            suppliername: node.vendorDetails.desc,
            subsidiaryName: node.subsidiary.name,
            desc: `${node.name} (${node.code})`,
            id: node.id,
            img,
            name: `${node.name} (${node.code})`,
            slNo: 0,
            companyId: node.curCompanyID,
            arms: node.arms,
            jType: node.jType,
            priority: node.priority,
            siteName: node.site.name,
            address: node?.address
          };

        default:
          break;
      }
      return assetData;
    };

    const fetchData = async () => {
      if (state.itemDetailsId) {
        GetItemDetails({
          variables: {
          
            id: state.itemDetailsId,
          },
        }).then(({ data }) => {
          if (data && data.node) {
            setAssetDetail(fetchProperData(data.node));
          }
        });
      }
    };
    fetchData();
  }, [state.itemDetailsId, GetItemDetails, data]);

  if (data) {
    return (
      <div className="maps-item-details__asset--h">
        <div
          className={`maps-item-details__asset--h--flex ${
            data.node.priority === PriorityEnum.CRITICAL
              ? "border-red"
              : data.node.priority === PriorityEnum.MEDIUM
              ? "border-yellow"
              : data.node.priority === PriorityEnum.LOW
              ? "border-green"
              : ""
          }

              `}
        >
          <img src={assetDetail.img} alt="" />
          <div>
            <b className="maps-item-details__asset--h--item">
              {assetDetail.desc}
            </b>

            {assetType === TableType.JUNCTION && (
              <div className="maps-item-details__asset--h--span">
                <span>{assetDetail.jType},</span>
                <span> {assetDetail.arms} Arms</span>
              </div>
            )}
          </div>
          {/* <div>
            <span>{assetDetail.subsidiaryName}</span>
            <span>{assetDetail.siteName}</span>
          </div> */}
        </div>
        {viewIcon ? (
          <CustomTooltip
            title={`View ${itemLabel} Details`}
            arrow
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  bgcolor: TOOLTIP_COLORS.VARIABLE,
                  "& .MuiTooltip-arrow": {
                    color: TOOLTIP_COLORS.VARIABLE,
                  },
                },
              },
            }}
          >
            <img
              src={Information}
              alt=""
              onClick={() => {
                if (assetType === TableType.JUNCTION) {
                  dispatch({
                    type: mapsPayloadType.ASSET_TYPE_ID,
                    payload: {
                      assetTypeId: data.node.id,
                    },
                  });
                  return setJunctionDetails(!junctionDetails);
                } else {
                  setItemdId(data.node.item.id);
                  setAssetDetailsModal(!assetDetailsModal);
                }
              }}
              className="maps-item-details__asset--h--image"
            />
          </CustomTooltip>
        ) : (
          ""
        )}

        <CustomModal
          isOpen={assetDetailsModal}
          onRequestClose={() => setAssetDetailsModal(!assetDetailsModal)}
          contentComponent={
            <ViewAsset setModalFlag={setAssetDetailsModal} itemId={itemId} />
          }
          style={ViewItemsModalStyles}
        />
      </div>
    );
  } else {
    return <b className="nodata">{itemLabel} not found</b>;
  }
};

export default ItemDetails;
